import { css } from "@emotion/react";

export const yearContainer = css`
    position: absolute;
    top: 60px;
    right: 10px;
    z-index: 99;
    text-align: right;
    padding-right: 2px;

    /* 전체 세로 라인 */
    &::before {
        content: "";
        position: absolute;
        top: 16px;
        bottom: 16px;
        right: 0;
        width: 2px;
        background: #7A7A7A;
    }
`

export const year = css`
    display: flex;
    justify-content: end;
    align-items: center;

    font-size: 16px;
    font-weight: 700;
    color: #7A7A7A;
    height: 32px;

    &::after {
        display: block;
        content: "";
        margin-left: 5px;
        background: #7A7A7A;;
        width: 8px;
        height: 2px;
        font-size: 0px;
        line-height: 0px;
    }

    &::before {
        content: "";
        position: absolute;
        right: -2px;
        width: 6px;
        height: 6px;
        background: #7A7A7A;
        border-radius: 50%;
    }
`

export const activeYear = css`
    font-size: 24px;
    font-weight: 1000;
    color: #000;
    height: 32px;
`